<template>
  <div v-if="allImages.length > 0" class="selected-image-container">
    <div v-for="(img, imgIdx) in allImages" :key="imgIdx" class="selected-image-details">
      <div class="name" @click="openFileImg(img)">{{ img.filename }}</div>
      <img v-if="allowDelete" class="delete-icon" src="@/assets/delete.png" alt="delete" @click="deleteImgClicked(imgIdx)">
    </div>
  </div>
  <div v-else>No image available</div>

  <Popup v-model:show="showImagePopup">
    <template v-slot:header>{{ fullImgName }}</template>
    <template v-slot:content>
      <img class="full-image-popup" :src="imgSrc" alt="">
    </template>
    <template v-slot:footer>
      <Button theme="danger" @click="showImagePopup = false">Close</Button>
    </template>
  </Popup>
</template>

<script setup lang="ts">
import { defineProps, defineEmits, ref, onMounted, withDefaults } from 'vue';
import { ImageDetails, ImageListing, ImageListingEvents } from './componentModel/ImageListContainerModel';
import { Popup, Button } from '../ts/components';

const props = withDefaults(defineProps<ImageListing>(), {
  allowDelete: false
});
const emit = defineEmits<ImageListingEvents>();

// #region Data
const showImagePopup = ref(false);
const fullImgName = ref('');
const imgSrc = ref<string | undefined>('');
const allImages = ref<ImageDetails[]>([]);
// #endregion Data

// #region Methods
const openFileImg = (file: ImageDetails) => {
  console.log(file);
  // Showing the popup
  showImagePopup.value = true;

  // Set the name
  fullImgName.value = file.filename;

  // Checking if the file is null or not
  if (file.file) {
    // Reading the file as data url to show in the full popup
    const reader = new FileReader();
    reader.onload = (ev: ProgressEvent<FileReader>) => {
      imgSrc.value = ev.target?.result as string | undefined;
    }
  
    reader.readAsDataURL(file.file);
  } else {
    imgSrc.value = `https://samuel-test.reeqzan.com/api/File/DownloadFile?file_uid=${file.uid}`;
  }
}
const deleteImgClicked = (idx: number) => {
  allImages.value.splice(idx, 1);
  emit('update:images', allImages.value);
}
// #endregion Methods

// #region Lifecycle
onMounted(() => {
  allImages.value = props.images;
})
// #endregion Lifecycle
</script>

<style scoped>

.selected-image-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.selected-image-details {
  display: flex;
  align-items: center;
  border: 1px solid gray;
  padding: 5px;
  border-radius: 10px;
  gap: 5px;
  overflow: hidden;
  
  > .name {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  > .delete-icon {
    width: 20px;
    cursor: pointer;
  }
}
.full-image-popup {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: contain;
}
</style>